import appConfig from '../../app.config';

import { Station } from '../slices/local/user';

export const getStationCover = (station: Station): string | null => {
  if (station?.thumbnailUri) {
    return station.thumbnailUri;
  }

  if(station?.images?.product?.cover){
    return `${appConfig.apiBaseUrl}${station.images.product.cover}`;
  }
  
  if (station?.images?.cover) {
    return `${appConfig.apiBaseUrl}${station.images.cover}`;
  }

  if (station?.images?.station?.original) {
    return `${appConfig.apiBaseUrl}${station.images.station.original}`;
  }

  if (station?.images?.station?.default) {
    return `${appConfig.apiBaseUrl}${station.images.station.default.inactive}`;
  }

  return null;
}
